/* eslint-disable @typescript-eslint/no-unused-vars */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
function isString(str) {
    return typeof str === 'string';
}
export default class Step extends React.Component {
    constructor() {
        super(...arguments);
        this.onClick = (...args) => {
            const { onClick, onStepClick, stepIndex } = this.props;
            if (onClick) {
                onClick(...args);
            }
            onStepClick(stepIndex);
        };
    }
    renderIconNode() {
        const { prefixCls, progressDot, stepIcon, stepNumber, status, title, description, icon, iconPrefix, icons } = this.props;
        let iconNode;
        const iconClassName = classNames(`${prefixCls}-icon`, `${iconPrefix}icon`, {
            [`${iconPrefix}icon-${icon}`]: icon && isString(icon),
            [`${iconPrefix}icon-check`]: !icon && status === 'finish' && ((icons && !icons.finish) || !icons),
            [`${iconPrefix}icon-cross`]: !icon && status === 'error' && ((icons && !icons.error) || !icons)
        });
        const iconDot = <span className={`${prefixCls}-icon-dot`}/>;
        // `progressDot` enjoy the highest priority
        if (progressDot) {
            if (typeof progressDot === 'function') {
                iconNode = (<span className={`${prefixCls}-icon`}>
                        {progressDot(iconDot, {
                        index: stepNumber - 1,
                        status,
                        title,
                        description
                    })}
                    </span>);
            }
            else {
                iconNode = <span className={`${prefixCls}-icon`}>{iconDot}</span>;
            }
        }
        else if (icon && !isString(icon)) {
            iconNode = <span className={`${prefixCls}-icon self`}>{icon}</span>;
        }
        else if (icons && icons.finish && status === 'finish') {
            iconNode = <span className={`${prefixCls}-icon`}>{icons.finish}</span>;
            // iconNode = <span className={`${prefixCls}-icon self`}>{stepNumber}</span>;
        }
        else if (icons && status === 'finish') {
            iconNode = <span className={`${prefixCls}-icon`}>{stepNumber}</span>;
        }
        else if (icons && icons.error && status === 'error') {
            iconNode = <span className={`${prefixCls}-icon`}>{icons.error}</span>;
        }
        else if (icon || status === 'finish' || status === 'error') {
            iconNode = <span className={iconClassName}/>;
        }
        else {
            iconNode = <span className={`${prefixCls}-icon`}>{stepNumber}</span>;
        }
        if (stepIcon) {
            iconNode = stepIcon({
                index: stepNumber - 1,
                status,
                title,
                description,
                node: iconNode
            });
        }
        return iconNode;
    }
    render() {
        const _a = this.props, { className, prefixCls, style, active, status = 'wait', icon, disabled, description, title, subTitle, tailContent, onStepClick, onClick, stepNumber, stepIndex, iconPrefix, wrapperStyle, progressDot, stepIcon } = _a, restProps = __rest(_a, ["className", "prefixCls", "style", "active", "status", "icon", "disabled", "description", "title", "subTitle", "tailContent", "onStepClick", "onClick", "stepNumber", "stepIndex", "iconPrefix", "wrapperStyle", "progressDot", "stepIcon"]);
        const classString = classNames(`${prefixCls}-item`, `${prefixCls}-item-${status}`, className, {
            [`${prefixCls}-item-custom`]: icon,
            [`${prefixCls}-item-active`]: active,
            [`${prefixCls}-item-disabled`]: disabled === true
        });
        const stepItemStyle = Object.assign({}, style);
        const accessibilityProps = {};
        if (onStepClick && !disabled) {
            accessibilityProps.role = 'button';
            accessibilityProps.tabIndex = 0;
            accessibilityProps.onClick = this.onClick;
        }
        return (<div {...restProps} className={classString} style={stepItemStyle}>
                <div onClick={onClick} {...accessibilityProps} className={`${prefixCls}-item-container`}>
                    <div className={`${prefixCls}-item-tail`}>{tailContent}</div>
                    <div className={`${prefixCls}-item-icon`}>{this.renderIconNode()}</div>
                    <div className={`${prefixCls}-item-content`}>
                        <div className={`${prefixCls}-item-title`}>
                            {title}
                            {subTitle && (<div title={typeof subTitle === 'string' ? subTitle : undefined} className={`${prefixCls}-item-subtitle`}>
                                    {subTitle}
                                </div>)}
                        </div>
                        {description && <div className={`${prefixCls}-item-description`}>{description}</div>}
                    </div>
                </div>
            </div>);
    }
}
